/**
 * Reducers are the pure functions (no side effects!) that update the store. Each
 * reducer updates the relevant part of the (single) store.
 *
 * This file combines all the reducers and exposes them as one data structure.
 */

import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import errors from './errors'
import loading from './loading'
import user from './user'
import transaction from './transaction'
import server from './server'
import multiRecipient from './multi-recipient'
import recipient from './recipient'
import contacts from './contacts'
import note from './note'
import giftOption from './giftOption'
import amount from './amount'
import crossBorder from './xb'
import overpanels from './overpanels'
import address from './address'
import card from './card'
import theme from './theme'
import unilateral from './unilateral'
import external from './external'
import billSplitting from './bill-splitting'
import story from './story'
import xsell from './xsell'
import donate from './donate'
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

const rootReducer = combineReducers({
  router: connectRouter(history),
  errors,
  loading,
  user,
  crossBorder,
  transaction,
  server,
  note,
  amount,
  overpanels,
  address,
  card,
  theme,
  unilateral,
  recipient,
  contacts,
  external,
  multiRecipient,
  billSplitting,
  giftOption,
  story,
  xsell,
  donate,
})

export default rootReducer
